import type { ReactNode } from "react";

type Props = {
  children: ReactNode;
  actions?: ReactNode;
};

export function AdminPageIntro({ children, actions }: Props) {
  return (
    <div
      className={`page__header page__header--admin${actions ? " page__header--row" : ""}`}
    >
      <p className="muted admin-page-intro__text">{children}</p>
      {actions ? <div className="admin-page-intro__actions">{actions}</div> : null}
    </div>
  );
}
